'use client'
import { LayoutBox } from "@/Components/Base";
import MdbChart from "@/Components/Chart/MdbChart";
import { IMAGES } from "@/Configs";
import { Logout } from "@/Functions/blueprint";
import { checkIp } from "@/Functions/Bulkpe";
import { getAuthTokenCk } from "@/Functions/Storage";
import { Alert, Grid } from "@mui/material";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose, faSignOut } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from "react";
import { toast } from "sonner";

export default function Home() {
  const [loader, setLoader] = useState<boolean>(true);
  const routes = useRouter()
  let Refresh = async (): Promise<boolean> => {
    let ss = await getAuthTokenCk();
    if (!ss.success) {
      routes.replace('/auth');
    }
    return true;
  }
  useEffect(() => {
    Refresh()
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      console.log('API called');
      let ss = await checkIp();
      if (!ss.success) {
        toast.warning(ss.message);
        await Logout()
        routes.replace('/auth');
      }
    };

    fetchData();

    const intervalId = setInterval(fetchData, 30000); // 30 seconds

    return () => {
      clearInterval(intervalId);
      console.log('Stopped API polling');
    };
  }, []);

  return (
    <LayoutBox sx={{}}>
      <Grid p={0} m={0} container sx={{ width: '100%' }} size={12} direction={"row"}>
        <Grid size={12} sx={{ height: '10vh', alignItems: 'center', p: 2, border: '1px solid  black' }} container>
          <Grid size={6} container>
            <Image src={IMAGES.logo} alt="bulkpe" style={{ height: 30, width: 'auto' }} />
          </Grid>
          <Grid size={6} container sx={{ justifyContent: 'flex-end', pr: 2 }}>
            <FontAwesomeIcon icon={faSignOut} size="lg" style={{ cursor: 'pointer' }} onClick={async () => {
              await Logout();
            }} />
          </Grid>
        </Grid>
        <Grid size={12} sx={{ height: '90vh' }} container >
          <MdbChart />
        </Grid>
      </Grid>
    </LayoutBox>
  );
}
